import { gql } from "@apollo/client";

export const CREATE_DESIGN = gql`
  mutation createDesign($input: DesignCreateInput!) {
    createDesign(input: $input) {
      _id
      name
      design
      marketPlaceType
      featuredImage
      images
      infill
      thickness
      price
      ownerId
      createdAt
      updatedAt
    }
  }
`;
